import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancel: {
    description: 'orderDetails.recipient.cancelBtn',
    defaultMessage: 'Cancel',
    id: 'hHKIhy',
  },
  save: {
    description: 'orderDetails.recipient.saveBtn',
    defaultMessage: 'Save',
    id: 'UErP9V',
  },
  taxInfo: {
    description: 'orderDetails.recipient.taxInfo',
    defaultMessage: 'Tax Information',
    id: 'bFkSHP',
  },
  editTaxIdInformation: {
    description: 'Information about tax identifier edition',
    defaultMessage: 'Add up to 3 recipient Tax Identifiers for this shipment.',
    id: 'RZgu75',
  },
});
